import React, { useEffect, useState } from "react";
import "./TechReviewerAdminTable.scss";
import ReactPaginate from "react-paginate";
import ReportGenerate from "../../reusables/ReportGenerate";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MainFile from "../../reusables/FormDownload/MainFile";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import ClearIcon from "@mui/icons-material/Clear";
import { Link } from "react-router-dom";
import axios from "axios";
import { getToken } from "../../auth/authConfig";
import FormViewDetails from "../../reusables/FormViewDetails";
import Download from "../../reusables/Model/Download";
import { Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { Alert, Box, CircularProgress, Modal } from "@mui/material";
import { login } from "../../auth/msalAuth";
import UploadFile from "./UploadFile";
const TechReviewerAdminTable = ({
  tableData,
  loading,
  error,
  title,
  color,
  expand,
  view,
  download,
  colorValue,
  buttonView,
  buttonText,
  version,
  uploadCertification,
  getFormListDetails
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(5);
  const [openPopup, setOpenPopup] = useState(false);
  const [openDownloadPopup, setOpenDownloadPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [FormDetails, setformDetails] = useState({});
  const [loadingData, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const search_parameters = ["uiut", "responsible_segment", "form_id"];
  let filteredData = [];
  filteredData = tableData.filter((obj) => {
    return obj;
  });

  function search(filteredData) {
    return filteredData.filter((item) =>
      search_parameters.some(
        (parameter) =>
          item[parameter] &&
          item[parameter]
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      )
    );
  }

  const renderSkeletonRows = () => {
    const skeletonRows = [];
    for (let i = 0; i < 5; i++) {
      skeletonRows.push(
        <tr key={`skeleton-${i}`}>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <Skeleton width={100} height={25} />
          </td>
          <td>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Skeleton circle={true} width={25} height={25} />
              <Skeleton circle={true} width={25} height={25} />
              <Skeleton circle={true} width={25} height={25} />
            </div>
          </td>
        </tr>
      );
    }
    return skeletonRows;
  };

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const transformData = (excelData) => {
    const newArray = excelData.map((obj) => {
      const functionValue = obj["function"];

      const {
        form_id,
        version,
        year_quarter,
        responsible_segment,
        uiut,
        phase,
        protocol_type,
        phase_status,
        activity,
      } = obj;

      console.log("obj", obj);
      return {
        "Audit Number": form_id || "N/A",
        Version: version || 0,
        "Year Quarter": year_quarter || "N/A",
        "Unit Index + Unit Name": uiut || "N/A",
        Segment: responsible_segment || "N/A",
        "Phase Stage": phase || "N/A",
        "Protocol Type": protocol_type || "N/A",
        "Phase Progress": phase_status || "N/A",
        "Overall Audit Progress": activity || "N/A",
        "Lead Auditor Email": obj.lead_auditor || "N/A",
        "Unit Admin Email": obj.unit_admin || "N/A",
      };
    });
    return newArray;
  };

  const getFormInformation = async (id) => {
    const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${id}`;
    const token = await getToken();
    try {
      setLoading(true);
      const response = await axios.get(viewUrl, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (response.status === 200) {
        //  setSnackbarMessage("Form Deleted Successfully!");
        //  setOpen(true);
        //  setOpenDeletePopup(false);
        //  setTimeout(() => setOpen(false), 3000);
        const data = response.data;
        setformDetails(data);
        setLoading(false);
        setOpenPopup(true);
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setIsError(true);
        setTimeout(() => {
          setIsError(false);
        }, 3000);
      }
      setLoading(false);
      console.log("getting error while calling the api");
    }
  };

  return (
    <>
      {loadingData && (
        <Modal open={loadingData}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full viewport height
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              backdropFilter: "blur(5px)", // Adding a blur effect for the background
              borderRadius: "10px", // Rounded corners
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      )}

      <SkeletonTheme baseColor="#d4d4d4" highlightColor="#f5f5f5">
        <div className="mars-form-main-container">
          {expand && tableData.length > 0 && (
            <div className="table-heading-section">
              <div
                style={{
                  display: "flex",
                  gap: "2rem",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="mars-admin-search-input-cont">
                  <input
                    type="text"
                    className="table-search-input"
                    placeholder="Search by Segment, or Unit Index + Unit Name"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                  <div className="search-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M18.0835 16.3331H17.1619L16.8352 16.0181C17.5643 15.171 18.0972 14.1733 18.3957 13.0963C18.6942 12.0193 18.7509 10.8896 18.5619 9.78806C18.0135 6.54473 15.3069 3.95473 12.0402 3.55806C10.8918 3.41277 9.7253 3.53213 8.63008 3.907C7.53485 4.28187 6.5399 4.90232 5.72135 5.72086C4.9028 6.53941 4.28236 7.53437 3.90749 8.62959C3.53261 9.72481 3.41326 10.8913 3.55855 12.0397C3.95521 15.3064 6.54521 18.0131 9.78855 18.5614C10.8901 18.7505 12.0197 18.6937 13.0968 18.3952C14.1738 18.0967 15.1715 17.5638 16.0185 16.8347L16.3335 17.1614V18.0831L21.2919 23.0414C21.7702 23.5197 22.5519 23.5197 23.0302 23.0414C23.5085 22.5631 23.5085 21.7814 23.0302 21.3031L18.0835 16.3331ZM11.0835 16.3331C8.17855 16.3331 5.83355 13.9881 5.83355 11.0831C5.83355 8.17806 8.17855 5.83306 11.0835 5.83306C13.9885 5.83306 16.3335 8.17806 16.3335 11.0831C16.3335 13.9881 13.9885 16.3331 11.0835 16.3331Z"
                        fill="#8D8D8D"
                      />
                    </svg>
                  </div>
                  {searchQuery.trim() !== "" && (
                    <ClearIcon
                      className="clear-icon"
                      onClick={() => setSearchQuery("")}
                    />
                  )}
                </div>
                <div style={{ position: "relative" }}>
                  <ReportGenerate
                    excelData={tableData}
                    fileName={`${title}_${new Date().getTime()}`}
                    transformData={transformData}
                    sheetName="Form Status"
                    className="RepoGen"
                    color={colorValue}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="home-table-container">
            <table className="home-table">
              <thead>
                <tr className={`form_${color}`}>
                  <th style={{ width: "8%" }}>Audit Number</th>
                  <th style={{ width: "5%" }}>Version</th>
                  <th style={{ width: "8%" }}>Year Quarter</th>
                  <th style={{ width: "12%" }}>Segment</th>
                  <th style={{ width: "20%" }}>Unit Index + Unit Name</th>
                  <th style={{ width: "10%" }}>Phase Stage</th>
                  <th style={{ width: "10%" }}>Protocol Type</th>
                  <th style={{ width: "10%" }}>Phase Progress</th>
                  <th style={{ width: "18%" }}>Overall Audit Progress</th>
                  <th style={{ width: "13%" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && renderSkeletonRows()}

                {!loading && !error && currentData.length === 0 && (
                  <tr>
                    <td colSpan={10}>No Data Available</td>
                  </tr>
                )}

                {!loading && !error && currentData.length !== 0 && (
                  <>
                    {currentData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.form_id || "N/A"}</td>
                        <td>
                          <span className={row.version === 2 ? 'bg-purple-200 p-2 rounded text-purple-700' : 'bg-[#ecec9e] p-2 rounded text-[#808000]'}>
                          {row.version ? `V${row.version}` : "N/A"}
                          </span>
                        </td>
                        <td>{row.year_quarter || "N/A"}</td>
                        <td>{row.responsible_segment || "N/A"}</td>
                        <td>{row.uiut || "N/A"}</td>
                        <td>
                          <span 
                          // className="bg-gray-200 p-2 rounded text-gray-700"
                          >{row.phase || "N/A"}</span>
                        </td>
                        <td>
                          <span 
                          className={row.protocol_type === 'Gap Assessment' ? 'bg-yellow-200 p-2 rounded text-yellow-700' : row.protocol_type === 'Addendum' ? 'bg-orange-200 p-2 rounded text-orange-700' :  row.protocol_type === 'Full Scope' ? 'bg-pink-200 p-2 rounded text-pink-700' : 'bg-gray-200 p-2 rounded text-gray-700'}
                          >
                              {row.protocol_type || "N/A"}
                          </span>
                        </td>
                        <td>
                          <span 
                          //  className={row.phase_status === 'Completed' ? "bg-green-200 p-2 rounded text-green-700" :  row.phase_status === 'In Progress' ? 'bg-blue-100 p-2 rounded text-blue-700' : 'bg-gray-200 p-2 rounded'}
                           >{row.phase_status || "N/A"}</span>
                        </td>
                        <td>
                          <span>
                          <span  
                          // className={(row.activity === 'Audited' || row.activity === 'Audited-V2') ? "bg-green-200 p-2 rounded text-green-700" :  row.activity === 'In Progress' ? 'bg-blue-100 p-2 rounded text-blue-700' : 'bg-gray-200 p-2 rounded'}
                          
                          >{row.activity || "N/A"}</span>

                          {/* {row.activity || "N/A"} */}
                          </span>
                        </td>
                        <td>
                          <div className="action-row-container">
                            <div className="actions-row">
                              {!view ? (
                                <>
                                  <Link
                                    to={`/audit/form?auditNumber=${row.form_id}`}
                                  >
                                    <div className="view-btn">
                                      <Button style={{}}>Review </Button>
                                    </div>
                                  </Link>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="view-btn"
                                    onClick={() => {
                                      // call the api and get the data of the purticular form
                                      getFormInformation(row.form_id);
                                    }}
                                  >
                                    <Button
                                      style={{
                                        backgroundColor: `${buttonView}`,
                                        border: "none",
                                        color: `${buttonText}`,
                                      }}
                                    >
                                      View
                                    </Button>
                                  </div>
                                </>
                              )}

                              {(download || row.activity === 'Certification Upload' || row.version === 2 ) ? (
                                <div className="download-btn">
                                  <Download
                                    row={row}
                                    form_id={row.form_id}
                                    phase={row.phase}
                                    protocol_type={row.protocol_type}
                                    version={version}
                                  />
                                </div>
                              ) : (
                                <div
                                // className="download-btn"
                                >
                                  <Button
                                    disabled
                                    style={{
                                      backgroundColor: `#D3D3D3`,
                                      border: "none",
                                      color: "#3d3d3d",
                                      cursor: "not-allowed",
                                    }}
                                  >
                                    Download
                                  </Button>
                                </div>
                              )}

                              {uploadCertification ? (
                                  <>
                                    <UploadFile formId={row.form_id} getFormListDetails={getFormListDetails}/>
                                  </>
                              ): (
                                <></>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}

                {!loading && error && (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center" }}>
                      {error}{" "}
                      <span
                        className="refresh-btn"
                        onClick={() => window.location.reload()}
                      >
                        Please try again
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {!error && !loading && search(filteredData).length > 5 && (
            <div className="pagination-cont">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handelepageclick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage - 1}
              />
            </div>
          )}

          <div id="form-view-popup">
            <Dialog
              open={openPopup}
              onClose={() => {
                setOpenPopup(false);
              }}
              id="form-view-modal"
            >
              {/* <DialogTitle id="alert-dialog-title">
            <div className="popup-header">
              <h3 style={{ textAlign: "center", marginBottom: "0" }}>
                Unit Details
              </h3>
            </div>
          </DialogTitle> */}
              <DialogContent>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      alignContent: "center",
                      paddingBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#3d3d3d",
                      }}
                    >
                      View Details For Audit Number {FormDetails?.formId}
                    </div>
                    <div>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => setOpenPopup(false)}
                      >
                        <FaTimes />
                      </div>
                    </div>
                  </div>
                  <FormViewDetails formDetails={FormDetails} />
                </div>
              </DialogContent>
              {/* <DialogActions
            style={{
              padding: "24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              className="logout-popup-btn primary-btn"
              onClick={() => {
                setOpen(false);
              }}
            >
              Yes
            </button>
            <button
              className="logout-popup-btn secondary-btn"
              onClick={() => {
                setOpen(false);
              }}
            >
              No
            </button>
          </DialogActions> */}
            </Dialog>
          </div>

          <div id="form-view-popup">
            <Dialog
              open={openDownloadPopup}
              onClose={() => {
                setOpenDownloadPopup(false);
              }}
              id="form-view-modal"
            >
              <DialogContent>
                <div>
                  <MainFile />
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </SkeletonTheme>

      {isError && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default TechReviewerAdminTable;
